import { useState } from "react";
import { toast } from "sonner";

export default function Contact() {
    const [form, setForm] = useState({ name: "", email: "", message: "" });
    const [sent, setSent] = useState(false);

    const submit = (e) => {
        e.preventDefault();
        if (!form.name || !form.email || !form.message) {
            toast.error("Please fill in every field — we love details.");
            return;
        }
        setSent(true);
        toast.success("Message received. We'll reply within 48 hours.");
        setForm({ name: "", email: "", message: "" });
    };

    return (
        <section
            id="contact"
            className="relative py-28 lg:py-36 bg-[var(--paper-2)] border-y-2 border-[var(--ink)]"
            data-testid="contact-section"
        >
            <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-[1fr_1.05fr] gap-14 items-start">
                <div className="reveal">
                    <div className="font-mono text-[10px] uppercase tracking-[0.3em] mb-5">
                        Sect. H — Get in touch
                    </div>
                    <h2 className="font-display text-6xl lg:text-9xl leading-[0.85] tracking-tighter">
                        Drop us a{" "}
                        <span className="font-italic-serif text-[var(--hot)]">
                            note.
                        </span>
                    </h2>
                    <p className="mt-7 max-w-md text-[var(--ink-soft)] leading-relaxed">
                        Feedback, partnerships, support, ideas, or just a hi —
                        everything goes to one mailbox for now. We read every
                        single message.
                    </p>

                    <div className="mt-10 space-y-4">
                        <div className="flex items-center gap-3">
                            <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-[var(--hot)] w-16">
                                Email
                            </span>
                            <a
                                href="mailto:workwithdilip1@gmail.com"
                                className="font-display text-2xl hover:text-[var(--hot)] transition"
                                data-testid="contact-email"
                            >
                                workwithdilip1@gmail.com
                            </a>
                        </div>
                        <div className="flex items-center gap-3">
                            <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-[var(--hot)] w-16">
                                HQ
                            </span>
                            <span className="font-display text-2xl">
                                Remote · Europe + India
                            </span>
                        </div>
                        <div className="flex items-center gap-3">
                            <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-[var(--hot)] w-16">
                                Contact
                            </span>
                            <a
                                href="mailto:workwithdilip1@gmail.com"
                                className="font-display text-2xl hover:text-[var(--hot)] transition"
                            >
                                workwithdilip1@gmail.com
                            </a>
                        </div>
                    </div>

                    <div className="mt-12 font-hand text-2xl text-[var(--hot)]">
                        — yours, always ♥
                    </div>
                </div>

                <form
                    onSubmit={submit}
                    className="reveal relative bg-[var(--paper)] border-2 border-[var(--ink)] p-7 lg:p-10 space-y-6"
                    data-testid="contact-form"
                >
                    <div className="stamp absolute -top-4 -right-4 bg-[var(--paper-2)]">
                        Postcard № 01
                    </div>
                    <div>
                        <label className="font-mono text-[10px] uppercase tracking-[0.25em]">
                            From
                        </label>
                        <input
                            type="text"
                            value={form.name}
                            onChange={(e) =>
                                setForm({ ...form, name: e.target.value })
                            }
                            className="mt-2 w-full bg-transparent border-b-2 border-[var(--ink)] focus:border-[var(--hot)] py-3 text-lg font-display outline-none transition"
                            placeholder="Your name"
                            data-testid="contact-name-input"
                        />
                    </div>
                    <div>
                        <label className="font-mono text-[10px] uppercase tracking-[0.25em]">
                            Return address
                        </label>
                        <input
                            type="email"
                            value={form.email}
                            onChange={(e) =>
                                setForm({ ...form, email: e.target.value })
                            }
                            className="mt-2 w-full bg-transparent border-b-2 border-[var(--ink)] focus:border-[var(--hot)] py-3 text-lg font-display outline-none transition"
                            placeholder="you@somewhere.com"
                            data-testid="contact-email-input"
                        />
                    </div>
                    <div>
                        <label className="font-mono text-[10px] uppercase tracking-[0.25em]">
                            Message
                        </label>
                        <textarea
                            value={form.message}
                            onChange={(e) =>
                                setForm({ ...form, message: e.target.value })
                            }
                            rows={5}
                            className="mt-2 w-full bg-transparent border-b-2 border-[var(--ink)] focus:border-[var(--hot)] py-3 text-lg font-display outline-none transition resize-none"
                            placeholder="Tell us what's on your mind…"
                            data-testid="contact-message-input"
                        />
                    </div>
                    <button
                        type="submit"
                        className="hot-button w-full inline-flex items-center justify-center gap-3 py-4 font-mono text-xs uppercase tracking-[0.25em] border-2 border-[var(--ink)]"
                        data-testid="contact-submit-button"
                    >
                        {sent ? "Sent — postmarked ♥" : "Send the letter"}
                    </button>
                </form>
            </div>
        </section>
    );
}
